import cxs from 'cxs';
import { MEDIA_QUERIES } from '../../../common/styles/vars';

const FORM_MARGIN_TOP = { marginTop: '15px' };

export const MANUAL_LOCATION_FORM = cxs({
  width: '100%',

  ' > label': {
    ...FORM_MARGIN_TOP,
    maxWidth: 'calc(50% - 10px)'
  }
});

export const INPUTS_CONTAINER = cxs({
  display: 'flex',
  ...FORM_MARGIN_TOP,

  ' > label': {
    display: 'block'
  },

  ' > label:not(:first-child)': {
    marginLeft: '10px'
  },

  [MEDIA_QUERIES.small]: {
    flexDirection: 'column',

    ' > label:not(:first-child)': {
      marginLeft: '0',
      marginTop: '15px'
    },

    ' > label': {
      width: '100%!important'
    }
  }
});

export const STREET_INPUTS_CONTAINER = cxs({
  ' > label:first-child': {
    width: '25%'
  }
});

export const COUNTRY_INPUTS_CONTAINER = cxs({
  ' > label:nth-child(1)': {
    width: '50%'
  },

  ' > label:nth-child(2)': {
    width: '25%'
  },

  ' > label:nth-child(3)': {
    width: '25%'
  }
});